import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ToolbarComponent } from "../../components/toolbar/toolbar.component";
import { MaterialModule } from "../../../material.module";
import { FlexLayoutModule } from "@angular/flex-layout";
import { SharedService } from "../../services/shared.service";
import { SharedComponent } from "../../components/shared/shared.component";
import { RouterModule } from "@angular/router";
import { FormsModule } from "@angular/forms";
import { UtilityComponent } from "../../components/utility/utility.component";
import { PageLayoutComponent } from "../../components/page-layout/page-layout.component";
import { SideNavComponent } from "../../components/side-nav/side-nav.component";
import { TopNavComponent } from "../../components/top-nav/top-nav.component";
import { HowToHomeComponent } from "../../components/how-to/how-to-home/how-to-home.component";
import { BusinessSetupComponent } from "../../components/how-to/business-setup/business-setup.component";
import { UserSetupComponent } from "../../components/how-to/user-setup/user-setup.component";
import { LinkSetupComponent } from "../../components/how-to/link-setup/link-setup.component";
import { TxnSetupComponent } from "../../components/how-to/txn-setup/txn-setup.component";
import { DataStore } from "../../data-store.service";

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    FlexLayoutModule,
    RouterModule,
    FormsModule
  ],
  declarations: [
    ToolbarComponent,
    SharedComponent,
    UtilityComponent,
    PageLayoutComponent,
    SideNavComponent,
    TopNavComponent,
    HowToHomeComponent,
    BusinessSetupComponent,
    UserSetupComponent,
    LinkSetupComponent,
    TxnSetupComponent,
  ],
  providers: [SharedService, UtilityComponent, DataStore],
  exports: [ToolbarComponent]
})
export class SharedModule {}
